import React from "react";

/** Inline WhatsApp brand mark. `currentColor` for easy theming. */
export default function WhatsAppIcon({ className = "h-4 w-4" }) {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={className}
      fill="currentColor"
    >
      <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.309-.101c-.885-.462-1.72-.996-2.487-1.641-.647-.541-1.222-1.176-1.706-1.887-.115-.183-.253-.42-.253-.635 0-.512.68-.848 1.088-1.336.144-.171.207-.412.207-.628 0-.412-.976-2.404-1.35-2.798-.148-.148-.331-.164-.535-.164-.148 0-.31.03-.443.03-.267 0-.454.037-.633.207-.55.541-.822 1.176-.822 1.982.036 1.687 1.351 3.256 2.487 4.375 1.641 1.641 3.463 2.869 5.596 3.489.336.106.688.176 1.048.176.717 0 1.664-.283 1.906-.837.152-.348.212-.731.212-1.109 0-.099-.03-.171-.061-.24-.121-.212-.393-.334-.663-.462zm-2.909-14.19c-7.043 0-12.769 5.726-12.769 12.769 0 2.245.596 4.464 1.712 6.402L2.5 29.5l7.517-2.646a12.696 12.696 0 0 0 6.183 1.63c7.044 0 12.77-5.726 12.77-12.77 0-3.409-1.331-6.611-3.746-9.026a12.681 12.681 0 0 0-9.024-3.732zm7.593 20.362a10.526 10.526 0 0 1-7.593 3.16 10.66 10.66 0 0 1-5.442-1.49l-.39-.232-4.464 1.564 1.591-4.353-.253-.404a10.62 10.62 0 0 1-1.643-5.679c0-5.865 4.775-10.64 10.64-10.64 2.837 0 5.502 1.105 7.516 3.11a10.567 10.567 0 0 1 3.11 7.53c0 2.836-1.105 5.501-3.11 7.515z" />
    </svg>
  );
}
